<template>
  <div class="wheel-battle-consumer-rank-tab">
    <div v-if="!standingList.length" class="empty-state">暂无排名数据</div>
    <div v-else class="rank-list">
      <div
        v-for="item in standingList"
        :key="item.team.id || item.team.name"
        class="rank-card"
      >
        <div class="rank-col">
          <img
            v-if="item.rank === 1"
            class="rank-icon"
            :src="rankIconUrls.first"
            alt="第1名"
          />
          <img
            v-else-if="item.rank === 2"
            class="rank-icon"
            :src="rankIconUrls.second"
            alt="第2名"
          />
          <img
            v-else-if="item.rank === 3"
            class="rank-icon"
            :src="rankIconUrls.third"
            alt="第3名"
          />
          <span v-else class="rank-text">{{ item.rank }}</span>
        </div>
        <div class="team-logo-wrap">
          <img
            v-if="getTeamLogoUrl(item.team, 35, 35)"
            :src="getTeamLogoUrl(item.team, 35, 35)"
            class="team-logo"
            alt=""
          />
          <div v-else class="team-logo team-logo-placeholder" />
        </div>
        <div class="team-name overflow-text">{{ item.team.name || '-' }}</div>
        <div class="win-stat">{{ item.win }}胜</div>
      </div>
    </div>
  </div>
</template>

<script>
import { resolveTeamLogoUrl } from '@/views/match-manage/wheel-battle/utils/team-logo'

var RANK_ICON_URLS = {
  first: 'https://images.snsports.cn/Fnnk6HvdErGp_eo5cD0MN-HQST_K',
  second: 'https://images.snsports.cn/Fizjt1IUtAqFKqpwhRtTGjMmYn0b',
  third: 'https://images.snsports.cn/FrbH-1paknF_7RVtt2fRUtYizJ5m'
}

export default {
  name: 'WheelBattleConsumerRankTab',
  props: {
    matchLogo: {
      type: String,
      default: ''
    },
    standing: {
      type: Array,
      default: function () {
        return []
      }
    }
  },
  data: function () {
    return {
      rankIconUrls: RANK_ICON_URLS
    }
  },
  computed: {
    standingList: function () {
      return this.standing || []
    }
  },
  methods: {
    getTeamLogoUrl: function (team, width, height) {
      return resolveTeamLogoUrl(team, this.matchLogo, width, height)
    }
  }
}
</script>

<style scoped lang="scss">
.wheel-battle-consumer-rank-tab {
  min-height: 240px;
  padding: 12px 16px 16px;
  background: #fff;
}

.empty-state {
  padding: 48px 16px;
  text-align: center;
  font-size: 14px;
  color: #909399;
}

.rank-list {
  display: flex;
  flex-direction: column;
}

.rank-card {
  display: flex;
  align-items: center;
  height: 85px;
  padding: 0 12px;
  margin-bottom: 10px;
  background: #f4f4f5;
  border-radius: 8px;
  box-sizing: border-box;

  &:last-child {
    margin-bottom: 0;
  }
}

.rank-col {
  flex-shrink: 0;
  width: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 10px;
}

.rank-icon {
  width: 22px;
  height: 26px;
  display: block;
  object-fit: contain;
}

.rank-text {
  min-width: 22px;
  font-size: 22px;
  font-style: italic;
  font-weight: 600;
  color: #6197c2;
  line-height: 1;
  text-align: center;
}

.team-logo-wrap {
  flex-shrink: 0;
  margin-right: 16px;
}

.team-logo {
  width: 35px;
  height: 35px;
  border-radius: 4px;
  object-fit: cover;
  display: block;
}

.team-logo-placeholder {
  background: #d9d9d9;
}

.team-name {
  flex: 1;
  min-width: 0;
  font-size: 16px;
  font-weight: 500;
  color: #303133;
  line-height: 22px;
}

.win-stat {
  flex-shrink: 0;
  margin-left: 8px;
  font-size: 16px;
  color: #606266;
  line-height: 22px;
}

.overflow-text {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
